import React from 'react'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import {selectLanguage} from '../../../../app/modules/auth'

import {Languages, PageUrl} from '../../../../app/utils/common/constants'
import {useAppSelector} from '../../../../setup/redux/Hooks'

type Props = {
  title?: string
  /** Optional module/section label shown as a "{parentLabel} · {title}" breadcrumb line above
   * the title — opt-in only, existing callers that omit it keep the previous bare-title layout. */
  parentLabel?: string
  actions?: React.ReactNode
}

const B8akToolbar: React.FC<Props> = ({title, parentLabel, actions}) => {
  const language = useAppSelector(selectLanguage)
  const {t} = useTranslation()

  return (
    <div className='row toolbar-b8ak my-5'>
      {parentLabel && (
        <div className='col-lg-12 col-sm-12'>
          <div className='text-muted small mb-1'>{parentLabel} · {title}</div>
        </div>
      )}
      <div className='col-lg-12 col-sm-12 d-flex justify-content-between align-items-center'>
        <h2 className='title mb-0'>{title}</h2>
        {actions && (
          <div className='d-flex' style={{ gap: '0.5rem' }}>
            {actions}
          </div>
        )}
      </div>
      {/* <div className='col-lg-12 col-sm-12 head-breadcrumb pt-18'>
      <Link to={PageUrl.HOME}>{t('HOME')}</Link>
      {language === Languages.ar ?
        <i className="fas fa-chevron-left mx-5"></i>
        : <i className="fas fa-chevron-right mx-5"></i>
      }
      <span>{title}</span>

    </div> */}
    </div>
  )
}

export {B8akToolbar}
